module.exports = __webpack_public_path__ + "media/customizations/camelback/back-ebc398e3a6a84c37d10b27cbcb60029d.jpg";